/* eslint-disable linebreak-style */
import {
  SET_CURRENT_PRODUCT, 
  SET_ORDERS_SUCCESS, 
  SET_CURRENT_ORDER,
  SET_CURRENT_ITEM,
  SET_UPDATED_ORDER,
  SET_DELETED_ITEMS,
  SET_EXPO_PREFILL
} from './order.actions.types'

const INITIAL_STATE = {
  // eslint-disable-next-line linebreak-style
  currentProduct:{},
  orders:[],
  ordersPagination:{
    page:1,
    pageSize:12,
    total:0,
    serverPaging:false,
    sort:'id:desc'
  },
  currentOrder:{},
  currentItem:{},
  updatedOrder:{},
  deletedItems:[],
  expoPrefill:null
};

const orderReducer=(state = INITIAL_STATE, action)=> {
  switch(action.type){
  //-------------------------------CURRENT PRODUCT
    case SET_CURRENT_PRODUCT:
      return {
        ...state, 
        currentProduct: action.payload,
        orders: [], // Curățăm comenzile când se schimbă produsul
        ordersPagination: {
          ...INITIAL_STATE.ordersPagination
        },
        currentOrder: {}, // Resetăm și comanda curentă
        currentItem: {}, // Resetăm și item-ul curent
        updatedOrder: {} // Resetăm și comanda actualizată
      } 
      //-------------------------------ORDERS
    
    case SET_ORDERS_SUCCESS: {
      // Backward compatible: payload poate fi array (legacy) sau obiect cu metadata de paginare.
      if (Array.isArray(action.payload)) {
        const shouldResetTotals = action.payload.length === 0 || !state.ordersPagination.serverPaging;
        return {
          ...state,
          orders: action.payload,
          ordersPagination: {
            ...state.ordersPagination,
            total: shouldResetTotals ? action.payload.length : state.ordersPagination.total
          }
        }
      }

      if (action.payload && Array.isArray(action.payload.items)) {
        const pagination = action.payload.pagination || {};
        return {
          ...state,
          orders: action.payload.items,
          ordersPagination: {
            page: Number(pagination.page || 1),
            pageSize: Number(pagination.pageSize || state.ordersPagination.pageSize || 12),
            total: Number(pagination.total || 0),
            serverPaging: Boolean(pagination.serverPaging),
            sort: pagination.sort || state.ordersPagination.sort || 'id:desc'
          }
        }
      }

      return {
        ...state, 
        orders:action.payload
      } 
    }

      //-------------------------------CURRENT ORDER
    
    case SET_CURRENT_ORDER:
      return {
        ...state, 
        currentOrder:action.payload
      } 
    //-------------------------------CURRENT ITEM
    case SET_CURRENT_ITEM:
      return {
        ...state, 
        currentItem:action.payload
      } 
    //-------------------------------UPDATED ORDER
    case SET_UPDATED_ORDER:
      return {
        ...state, 
        updatedOrder:action.payload
      } 
    //-------------------------------DELETED ITEMS
    case SET_DELETED_ITEMS:
      return {
        ...state, 
        deletedItems:action.payload
      } 
    case SET_EXPO_PREFILL:
      return {
        ...state,
        expoPrefill: action.payload
      }
    
    default:
      return state;
  }
};
  
export default orderReducer;